import BaseModal from 'app/views/modals/base_modal';
import ApiKey from 'app/models/api_key';
import tmpl from 'templates/create_api_key_modal';
import { showError } from 'utils/messages';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .cancel': 'close',
    'click .create-api-key': 'createApiKey',
  },

  createApiKey() {
    const apiKey = new ApiKey();
    apiKey.createApiKey({
      mode: this.$('[name=api-key-type]:checked').val(),
    }, {
      afterCreateSuccess: (model) => {
        this.collection.add(model);
        this.close();
      },
      afterCreateError: () => {
        showError('There was a problem submitting your request: If this continues, please let us know at support@easypost.com.');
        this.close();
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/create_api_key_modal.js